class WhatsIncluded extends HTMLElement {
  constructor() {
    super();
    const allThumbnails = this.querySelectorAll('.thumb');

    this.slider = this.querySelector('[id^="Parent-Slider-"]');

    allThumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {

        // Slide to Correct Slide
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

        let step = parseInt(thumbnail.dataset.slide) - 1;

        this.slideScrollPosition = this.sliderItemsToShow[step].offsetLeft;
        this.slider.scrollTo({
          left: this.slideScrollPosition
        });

        // Change Active Thumbnail
        thumbnail.classList.add('is-active');

        allThumbnails.forEach((inactiveLink) => {
          if(inactiveLink != thumbnail){
            inactiveLink.classList.remove('is-active');
          }
        });

      })
    });

  }

}

customElements.define('whats-included', WhatsIncluded);